import React from "react";
import { Link } from "@reach/router";
import moment from "moment";

const AttemptRow = ({ attempt }) => {
  const renderCourse = () => {
    const course = attempt.test?.course;
    if (course && course !== null) {
      return course.name;
    }
    return "N/D";
  };

  const renderDate = (date) => {
    if (date === null || date === undefined) {
      return "-";
    }
    return moment(date).format("DD MMM YY HH:mm");
  };

  const renderResult = () => {
    if (attempt.finishedAt === null) {
      return <span className="badge badge-pill bg-secondary">Sin Terminar</span>;
    }
    if (attempt.score === null) {
      return <span className="badge badge-pill bg-warning text-dark">En Revisión</span>;
    }
    const approved =
      parseFloat(attempt.score) >= parseFloat(attempt.test?.min_score);
    return (
      <span
        className={`badge badge-pill ${approved ? "bg-success" : "bg-danger"}`}
      >
        {approved ? "Aprobado" : "No Aprobado"}
      </span>
    );
  };

  return (
    <tr className="border">
      <td>{attempt.test?.name}</td>
      <td>{renderCourse()}</td>
      <td>{renderDate(attempt.createdAt)}</td>
      <td>{renderDate(attempt.finishedAt)}</td>
      <td>{attempt.score !== null ? attempt.score : "-"}</td>
      <td>{renderResult()}</td>
      <td>
        <Link
          to={`/mytbm/attempt/${attempt.attempt_id}`}
          className="btn btn-link px-0 py-0 text-primary"
          title="Ver evaluación"
        >
          Ver Evaluación
        </Link>
      </td>
    </tr>
  );
};

export default AttemptRow;
